import { Helmet } from "react-helmet-async";

interface Props {
  title: string;
  description: string;
  slug: string;
  image?: string;
}

const SITE_URL = "https://www.magicprint.nl";

const ArticleSchema = ({ title, description, slug, image }: Props) => {
  const url = `${SITE_URL}${slug.startsWith("/") ? slug : `/${slug}`}`;
  const data = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    image: image ? [image.startsWith("http") ? image : `${SITE_URL}${image}`] : [`${SITE_URL}/og-image.jpg`],
    author: { "@type": "Organization", name: "Magic Print" },
    publisher: {
      "@type": "Organization",
      name: "Magic Print",
      logo: { "@type": "ImageObject", url: `${SITE_URL}/og-image.jpg` },
    },
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
  };
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default ArticleSchema;
